const OVERVIEW_HOME_PATH = '/app/overview';
const MEETINGS_HOME_PATH = '/app/overview/meetings';

export const OVERVIEW_MOBILE_NAV_PATHS = {
  appointments: {
    home: OVERVIEW_HOME_PATH,
    today: `${OVERVIEW_HOME_PATH}/today`,
    pending: `${OVERVIEW_HOME_PATH}/pending`,
    updates: `${OVERVIEW_HOME_PATH}/updates`,
  },
  meetings: {
    home: MEETINGS_HOME_PATH,
    today: `${MEETINGS_HOME_PATH}/today`,
    pending: `${MEETINGS_HOME_PATH}/pending`,
    updates: `${OVERVIEW_HOME_PATH}/updates`,
  },
};

export const isOverviewMobileNavPath = (pathname) => {
  const paths = [
    OVERVIEW_HOME_PATH,
    `${OVERVIEW_HOME_PATH}/today`,
    `${OVERVIEW_HOME_PATH}/pending`,
    `${OVERVIEW_HOME_PATH}/updates`,
    MEETINGS_HOME_PATH,
    `${MEETINGS_HOME_PATH}/today`,
    `${MEETINGS_HOME_PATH}/pending`,
  ];

  return paths.includes(pathname);
};

export const getOverviewMobileNavMode = (pathname) => (
  pathname.startsWith(MEETINGS_HOME_PATH) ? 'meetings' : 'appointments'
);

export const getOverviewMobileNavActiveItem = (pathname) => {
  if (pathname.endsWith('/today')) return 'today';
  if (pathname.endsWith('/pending')) return 'pending';
  if (pathname.endsWith('/updates')) return 'updates';
  return 'home';
};
